<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="EBook-Break" id="_idParaDest-3"> </p>
<p class="BT1stPara ParaOverride-1"><span class="CharOverride-3">Secessia</span></p>
<p class="BT1stPara ParaOverride-3"><span class="CharOverride-4">Kent Wascom</span></p>
<p class="BT1stPara ParaOverride-4"><img alt="" class="_idGenObjectAttribute-1" src="image/V-1.png"/></p>
<p class="BT1stPara ParaOverride-1">Grove Press</p>
<p class="BT1stPara ParaOverride-1"><span class="CharOverride-2">New York</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eBook43512.vue?4f9b214c